export const comics = [
  {
    id: 1,
    slug: 'wo-de-jiejie-shi-dachui',
    title: '我的姐姐是大触',
    author: '李智恩',
    category: 'hanman',
    categoryName: '韩漫',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20illustration%20of%20a%20young%20woman%20with%20long%20dark%20hair%2C%20soft%20watercolor%20style%2C%20warm%20pink%20and%20peach%20tones%2C%20romantic%20atmosphere%2C%20clean%20minimal%20composition%2C%20Korean%20manhwa%20cover%20art%2C%20delicate%20facial%20features%2C%20soft%20lighting%2C%20pastel%20background%2C%20vertical%20portrait%20layout%2C%20professional%20digital%20illustration%20with%20gentle%20gradients&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    description: '当平凡的女高中生发现自己那位看似普通的姐姐，竟然是一位拥有数百万粉丝的人气漫画家时，一切都变得不平凡了……',
    rating: 9.6,
    views: '1280万',
    chapters: 86,
    status: '连载中',
    tags: ['恋爱', '日常', '治愈'],
    updateTime: '2026-07-03',
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 2,
    slug: 'jueshi-wuhun',
    title: '绝世武魂',
    author: '洛城东',
    category: 'rexue',
    categoryName: '热血',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20fantasy%20martial%20arts%20webtoon%20illustration%20of%20a%20young%20male%20warrior%20with%20glowing%20sword%2C%20epic%20battle%20pose%2C%20dramatic%20lighting%20with%20golden%20and%20crimson%20tones%2C%20floating%20energy%20particles%2C%20clean%20composition%2C%20professional%20Korean%20manhwa%20style%2C%20vertical%20portrait%2C%20intense%20expression%2C%20dark%20mystical%20background%20with%20soft%20glow%20effects&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    description: '少年陈枫，丹田破碎，却意外获得绝世武魂，从此踏上逆天改命的修炼之路。',
    rating: 9.3,
    views: '2150万',
    chapters: 312,
    status: '连载中',
    tags: ['玄幻', '战斗', '升级'],
    updateTime: '2026-07-02',
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 3,
    slug: 'hunyin-de-beiju',
    title: '婚姻的悲剧',
    author: '宋智恩',
    category: 'hanman',
    categoryName: '韩漫',
    cover: 'https://readdy.ai/api/search-image?query=A%20melancholic%20Korean%20webtoon%20illustration%20of%20a%20woman%20in%20a%20wedding%20dress%20with%20tearful%20eyes%2C%20dramatic%20emotional%20expression%2C%20soft%20grey%20and%20lavender%20color%20palette%2C%20romantic%20yet%20sad%20atmosphere%2C%20floating%20rose%20petals%2C%20clean%20manhwa%20art%20style%2C%20vertical%20portrait%2C%20professional%20digital%20illustration%2C%20delicate%20lighting%2C%20emotional%20storytelling%20visual&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    rating: 9.1,
    views: '890万',
    chapters: 52,
    status: '完结',
    tags: ['剧情', '情感', '现实'],
    updateTime: '2026-06-28',
    isHot: false,
    isNew: false,
    isCompleted: true,
  },
  {
    id: 4,
    slug: 'mofa-shaonv-xiaomei',
    title: '魔法少女小美',
    author: '苏小暖',
    category: 'shaonv',
    categoryName: '少女',
    cover: 'https://readdy.ai/api/search-image?query=A%20cute%20magical%20girl%20webtoon%20illustration%20in%20Korean%20manhwa%20style%2C%20young%20girl%20with%20pink%20hair%20and%20magical%20wand%2C%20sparkling%20stars%20and%20ribbons%2C%20pastel%20pink%20and%20mint%20green%20color%20palette%2C%20kawaii%20aesthetic%2C%20clean%20composition%2C%20vertical%20portrait%2C%20soft%20dreamy%20background%2C%20shojo%20manga%20inspired%2C%20gentle%20lighting&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    rating: 9.4,
    views: '1560万',
    chapters: 128,
    status: '连载中',
    tags: ['魔法', '校园', '友情'],
    updateTime: '2026-07-03',
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 5,
    slug: 'anying-baojun',
    title: '暗影暴君',
    author: '黑翼',
    category: 'rexue',
    categoryName: '热血',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20webtoon%20illustration%20of%20a%20powerful%20male%20character%20in%20black%20armor%20with%20shadowy%20aura%2C%20intense%20red%20eyes%2C%20dramatic%20dark%20color%20scheme%20with%20crimson%20accents%2C%20Korean%20manhwa%20style%2C%20vertical%20portrait%2C%20mysterious%20dark%20castle%20background%2C%20professional%20digital%20art%2C%20clean%20composition%2C%20ominous%20atmosphere&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    rating: 9.5,
    views: '3200万',
    chapters: 198,
    status: '连载中',
    tags: ['暗黑', '复仇', '战斗'],
    updateTime: '2026-07-01',
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 6,
    slug: 'tianmi-qihou',
    title: '甜蜜期后',
    author: '安知晓',
    category: 'hanman',
    categoryName: '韩漫',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20webtoon%20illustration%20of%20a%20couple%20sitting%20back%20to%20back%20with%20complex%20expressions%2C%20warm%20amber%20and%20rose%20tones%2C%20emotional%20relationship%20drama%20vibe%2C%20clean%20manhwa%20art%20style%2C%20vertical%20portrait%2C%20soft%20evening%20light%2C%20urban%20rooftop%20background%2C%20professional%20digital%20illustration&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    rating: 8.9,
    views: '670万',
    chapters: 44,
    status: '完结',
    tags: ['恋爱', '职场', '现实'],
    updateTime: '2026-06-25',
    isHot: false,
    isNew: true,
    isCompleted: true,
  },
  {
    id: 7,
    slug: 'shenmi-shangdian',
    title: '神秘商店',
    author: '夜不语',
    category: 'xuanyi',
    categoryName: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20thriller%20webtoon%20illustration%20of%20an%20antique%20shop%20at%20night%20with%20a%20shadowy%20figure%2C%20dim%20warm%20light%20from%20inside%2C%20dark%20teal%20and%20amber%20color%20palette%2C%20Korean%20manhwa%20style%2C%20vertical%20portrait%2C%20suspenseful%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20art%2C%20eerie%20yet%20beautiful&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    rating: 9.7,
    views: '1980万',
    chapters: 95,
    status: '连载中',
    tags: ['悬疑', '奇幻', '都市'],
    updateTime: '2026-07-02',
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 8,
    slug: 'xiao-chang-chushi',
    title: '校草初识',
    author: '唐七',
    category: 'shaonv',
    categoryName: '少女',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20school%20romance%20webtoon%20illustration%20of%20a%20handsome%20male%20student%20and%20a%20shy%20female%20student%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20white%20color%20palette%2C%20Korean%20manhwa%20style%2C%20vertical%20portrait%2C%20spring%20atmosphere%2C%20clean%20composition%2C%20youthful%20and%20fresh%2C%20professional%20digital%20illustration%2C%20gentle%20sunlight&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    rating: 9.2,
    views: '1450万',
    chapters: 72,
    status: '连载中',
    tags: ['校园', '恋爱', '青春'],
    updateTime: '2026-07-03',
    isHot: false,
    isNew: true,
    isCompleted: false,
  },
  {
    id: 9,
    slug: 'qihuan-shijie-lvxing',
    title: '奇幻世界旅行',
    author: '柳下挥',
    category: 'qihuan',
    categoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20adventure%20webtoon%20illustration%20of%20a%20young%20explorer%20in%20a%20magical%20forest%20with%20glowing%20creatures%2C%20vibrant%20emerald%20and%20golden%20color%20palette%2C%20Korean%20manhwa%20style%2C%20vertical%20portrait%2C%20mystical%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20art%2C%20enchanted%20forest%20background%2C%20soft%20magical%20glow&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    rating: 9.0,
    views: '760万',
    chapters: 63,
    status: '连载中',
    tags: ['冒险', '异世界', '魔法'],
    updateTime: '2026-06-30',
    isHot: false,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 10,
    slug: 'gaoxiao-richang',
    title: '搞笑日常',
    author: '使徒子',
    category: 'gaoxiao',
    categoryName: '搞笑',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20comedy%20webtoon%20illustration%20with%20exaggerated%20facial%20expressions%2C%20bright%20yellow%20and%20orange%20color%20palette%2C%20Korean%20manhwa%20chibi%20style%2C%20vertical%20portrait%2C%20playful%20and%20energetic%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20illustration%2C%20cartoonish%20humor%20vibe%2C%20simple%20colorful%20background&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    rating: 9.3,
    views: '2340万',
    chapters: 256,
    status: '连载中',
    tags: ['搞笑', '日常', '四格'],
    updateTime: '2026-07-03',
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 11,
    slug: 'danmei-zhi-wang',
    title: '耽美之王',
    author: '墨香铜臭',
    category: 'danmei',
    categoryName: '耽美',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20boys%20love%20webtoon%20illustration%20of%20two%20elegant%20young%20men%20in%20traditional%20Chinese%20robes%2C%20soft%20lavender%20and%20silver%20color%20palette%2C%20Korean%20manhwa%20style%2C%20vertical%20portrait%2C%20romantic%20ancient%20Chinese%20setting%2C%20clean%20composition%2C%20professional%20digital%20art%2C%20ethereal%20atmosphere%2C%20floating%20flower%20petals&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    rating: 9.8,
    views: '4100万',
    chapters: 156,
    status: '连载中',
    tags: ['耽美', '古风', '剧情'],
    updateTime: '2026-07-02',
    isHot: true,
    isNew: false,
    isCompleted: false,
  },
  {
    id: 12,
    slug: 'dushi-xiuzhen-zhe',
    title: '都市修真者',
    author: '忘语',
    category: 'guoman',
    categoryName: '国漫',
    cover: 'https://readdy.ai/api/search-image?query=A%20modern%20cultivation%20webtoon%20illustration%20of%20a%20young%20man%20in%20urban%20setting%20with%20spiritual%20energy%20flowing%20around%2C%20neon%20cyan%20and%20dark%20blue%20color%20palette%2C%20Korean%20manhwa%20style%20mixed%20with%20Chinese%20aesthetics%2C%20vertical%20portrait%2C%20cyberpunk%20meets%20cultivation%20vibe%2C%20clean%20composition%2C%20professional%20digital%20art&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    rating: 9.1,
    views: '1870万',
    chapters: 220,
    status: '连载中',
    tags: ['修真', '都市', '升级'],
    updateTime: '2026-07-01',
    isHot: false,
    isNew: false,
    isCompleted: false,
  },
];

export const popularComics = comics.filter(c => c.isHot).slice(0, 6);

export const newComics = comics.filter(c => c.isNew).slice(0, 4);

export const completedComics = comics.filter(c => c.isCompleted).slice(0, 4);